function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 221,
  height: 279,
  fill: "#E8EEFD"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 221,
  height: 279,
  stroke: "#CDDBFE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48 52V76V92H79",
  stroke: "white",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeDasharray: "8 8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M48 227.5V200H104V216.5",
  stroke: "white",
  strokeWidth: 4
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M112 52V72V92H78L78 130V166",
  stroke: "white",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeDasharray: "8 8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M182 140L162 140L142 140L142 116L125 116L110 116L79.5 116",
  stroke: "white",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeDasharray: "8 8"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 24,
  fill: "#D9D9D9"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 24,
  fill: "#9FB4F9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 64,
  r: 16,
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 44,
  r: 8,
  fill: "#E8EEFD"
})));

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 48,
  r: 24,
  fill: "#D9D9D9"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 48,
  r: 24,
  fill: "#9FB4F9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 64,
  r: 16,
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 44,
  r: 8,
  fill: "#E8EEFD"
})));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M78 190V198V202",
  stroke: "white",
  strokeWidth: 4
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_d_4983_80112)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 54,
  y: 144,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#B3C6FC",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64 157C64 156.448 64.4477 156 65 156H73.382C73.7607 156 74.107 156.214 74.2764 156.553L76 160H64V157Z",
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_d_4983_80112)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64 160H90C91.1046 160 92 160.895 92 162V178C92 179.105 91.1046 180 90 180H66C64.8954 180 64 179.105 64 178V160Z",
  fill: "#E8EEFD"
})));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_d_4983_80112)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 208,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#DE9EFF",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 224,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 224,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter9_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 240,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter10_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 240,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter11_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 240,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter12_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 240,
  r: 4,
  fill: "#F6E8FE"
})));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter13_d_4983_80112)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 80,
  y: 208,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#DE9EFF",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter14_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 224,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter15_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 224,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter16_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 240,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter17_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 240,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter18_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 240,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter19_d_4983_80112)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 240,
  r: 4,
  fill: "#F6E8FE"
})));

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M182 115V148V152",
  stroke: "white",
  strokeWidth: 4
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2_4983_80112)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M180 89.1547C181.238 88.4402 182.762 88.4402 184 89.1547L200.785 98.8453C202.022 99.5598 202.785 100.88 202.785 102.309V121.691C202.785 123.12 202.022 124.44 200.785 125.155L184 134.845C182.762 135.56 181.238 135.56 180 134.845L163.215 125.155C161.978 124.44 161.215 123.12 161.215 121.691V102.309C161.215 100.88 161.978 99.5598 163.215 98.8453L180 89.1547Z",
  fill: "#6CE2FE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter20_d_4983_80112)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M181.493 92.2982C181.806 92.1142 182.194 92.1142 182.507 92.2982L198.507 101.71C198.812 101.89 199 102.218 199 102.572V121.428C199 121.782 198.812 122.11 198.507 122.29L182.507 131.702C182.194 131.886 181.806 131.886 181.493 131.702L165.493 122.29C165.188 122.11 165 121.782 165 121.428V102.572C165 102.218 165.188 101.89 165.493 101.71L181.493 92.2982Z",
  fill: "#CEFCFE"
})), /*#__PURE__*/React.createElement("path", {
  d: "M182 92L199 102V122L182 132L165 122V102L182 92Z",
  fill: "#CEFCFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter21_d_4983_80112)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M182 112V132L165 122V102L182 112Z",
  fill: "#9DF2FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter22_d_4983_80112)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M182 112V132L199 122V102L182 112Z",
  fill: "#9DF2FE"
})));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip3_4983_80112)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M180 145.155C181.238 144.44 182.762 144.44 184 145.155L200.785 154.845C202.022 155.56 202.785 156.88 202.785 158.309V177.691C202.785 179.12 202.022 180.44 200.785 181.155L184 190.845C182.762 191.56 181.238 191.56 180 190.845L163.215 181.155C161.978 180.44 161.215 179.12 161.215 177.691V158.309C161.215 156.88 161.978 155.56 163.215 154.845L180 145.155Z",
  fill: "#6CE2FE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter23_d_4983_80112)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M181.493 148.298C181.806 148.114 182.194 148.114 182.507 148.298L198.507 157.71C198.812 157.89 199 158.218 199 158.572V177.428C199 177.782 198.812 178.11 198.507 178.29L182.507 187.702C182.194 187.886 181.806 187.886 181.493 187.702L165.493 178.29C165.188 178.11 165 177.782 165 177.428V158.572C165 158.218 165.188 157.89 165.493 157.71L181.493 148.298Z",
  fill: "#CEFCFE"
})), /*#__PURE__*/React.createElement("path", {
  d: "M182 148L199 158V178L182 188L165 178V158L182 148Z",
  fill: "#CEFCFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter24_d_4983_80112)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M182 168V188L165 178V158L182 168Z",
  fill: "#9DF2FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter25_d_4983_80112)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M182 168V188L199 178V158L182 168Z",
  fill: "#9DF2FE"
})));

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_4983_80112",
  x: 12,
  y: 20,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_4983_80112",
  x: 28,
  y: 32,
  width: 40,
  height: 40,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d_4983_80112",
  x: 76,
  y: 20,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_d_4983_80112",
  x: 92,
  y: 32,
  width: 40,
  height: 40,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_d_4983_80112",
  x: 42,
  y: 140,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_d_4983_80112",
  x: 52,
  y: 148,
  width: 52,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_d_4983_80112",
  x: 12,
  y: 204,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_d_4983_80112",
  x: 34,
  y: 212,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_d_4983_80112",
  x: 36,
  y: 214,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter9_d_4983_80112",
  x: 26,
  y: 228,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter10_d_4983_80112",
  x: 28,
  y: 230,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter11_d_4983_80112",
  x: 42,
  y: 228,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter12_d_4983_80112",
  x: 44,
  y: 230,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter13_d_4983_80112",
  x: 68,
  y: 204,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter14_d_4983_80112",
  x: 90,
  y: 212,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter15_d_4983_80112",
  x: 92,
  y: 214,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter16_d_4983_80112",
  x: 82,
  y: 228,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter17_d_4983_80112",
  x: 84,
  y: 230,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter18_d_4983_80112",
  x: 98,
  y: 228,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter19_d_4983_80112",
  x: 100,
  y: 230,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter20_d_4983_80112",
  x: 157,
  y: 84.1602,
  width: 50,
  height: 55.6797,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.280084 0 0 0 0 0.646911 0 0 0 0 0.998454 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter21_d_4983_80112",
  x: 157,
  y: 96,
  width: 33,
  height: 46,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.280084 0 0 0 0 0.646911 0 0 0 0 0.998454 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter22_d_4983_80112",
  x: 174,
  y: 96,
  width: 33,
  height: 46,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.280084 0 0 0 0 0.646911 0 0 0 0 0.998454 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter23_d_4983_80112",
  x: 157,
  y: 140.16,
  width: 50,
  height: 55.6797,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.280084 0 0 0 0 0.646911 0 0 0 0 0.998454 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter24_d_4983_80112",
  x: 157,
  y: 152,
  width: 33,
  height: 46,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.280084 0 0 0 0 0.646911 0 0 0 0 0.998454 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter25_d_4983_80112",
  x: 174,
  y: 152,
  width: 33,
  height: 46,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.280084 0 0 0 0 0.646911 0 0 0 0 0.998454 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80112"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80112",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4983_80112"
}, /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 24,
  width: 48,
  height: 48,
  rx: 24,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_4983_80112"
}, /*#__PURE__*/React.createElement("rect", {
  x: 88,
  y: 24,
  width: 48,
  height: 48,
  rx: 24,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2_4983_80112"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white",
  transform: "translate(158 88)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip3_4983_80112"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white",
  transform: "translate(158 144)"
})));

function SvgResources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 280,
    viewBox: "0 0 222 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4983_80112)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4983_80112)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4983_80112",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 48,
    height: 48
  }, _ref8), _ref9)), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4983_80112)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4983_80112)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4983_80112",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 24,
    width: 48,
    height: 48
  }, _ref10), _ref11)), _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.47ef48ea13f8ea1dc68a7c4251505890.svg";
export { ForwardRef as ReactComponent };